//loadData
const PROPERTIES_UNITS_FETCH_INITIAL_DATA = "properties_units/fetch_initial_data"
const LOAD_PROPERTIES_UNITS_TENANTS = "properties_units_tenants/fetch"

// properties
const ADD_PROPERTY = 'properties/add';
const UPDATE_PROPERTY = 'properties/update';
const DELETE_PROPERTY = 'properties/delete';
const LOAD_PROPERTIES = "properties/fetch";

// units
const ADD_UNIT = 'units/add';
const UPDATE_UNIT = 'units/update';
const DELETE_UNIT = 'units/delete';
const LOAD_UNITS = "units/fetch";

// Tenants
const ADD_TENANT = "tenant/add";
const UPDATE_TENANT = "tenant/update";
const DELETE_TENANT = "tenant/delete";
const FETCH_TENANTS = "tenants/fetch";
const FETCH_PROPERTY_TENANTS = "tenants/property_fetch";
const GET_TENANT_IN_UNIT = "unit_tenant/fetch";
const SHIFT_TENANT = "tenant/shift";
const FETCH_TENANT_DATA = "tenant/fetch/data";

// Landlords
const ADD_LANDLORD = "landlord/add";
const UPDATE_LANDLORD = "landlord/update";
const DELETE_LANDLORD = "landlord/delete";
const FETCH_LANDLORDS = "landlords/fetch";

//Bulk Upload
const BULK_UPLOAD = 'properties_units_tenants/bulk_upload';
const UPLOAD_BULK_TRANSACTIONS = 'transactions/bulk_upload';


// Team
const ADD_TEAM_MEMBER = "team/add";
const UPDATE_TEAM_MEMBER = "team/update";
const DELETE_TEAM_MEMBER = "team/delete";
const FETCH_TEAM = "team/fetch";


// Financials
const ADD_PAYMENT = 'payments/add';
const ASSIGN_PAYMENT = 'payments/assign';
const REALLOCATE_PAYMENT = 'payments/reallocate';
const UPDATE_PAYMENT = "payments/update";
const DELETE_PAYMENTS = "payments/delete";
const FETCH_PAYMENTS = "payments/fetch";
const FETCH_FINANCIALS_GRAPH = "financials-graph/fetch";

const ADD_INVOICE = "invoice/add";
const BULK_ADD_INVOICES = "invoice/addBulk";
const UPDATE_INVOICE = "invoice/update";
const DELETE_INVOICES = "invoice/delete";
const FETCH_INVOICES = "invoices/fetch";
const FETCH_SINGLE_INVOICE = "invoice/fetch";
const CREATE_PROPERTY_INVOICES = "propertyInvoices/create";
const CREATE_RECURRING_BILLS_INVOICES = "RecurringBillsInvoices/create"
const CALCULATE_BULK_INVOICES = "bulkInvoices/calculate";
const CREATE_BULK_INVOICES = "bulkInvoices/create";

const FETCH_TRANSACTIONS  = "transactions/fetch";

//Expenses
const ADD_EXPENSE = 'expense/add';
const UPDATE_EXPENSE = "expense/update";
const DELETE_EXPENSE = "expense/delete";
const FETCH_EXPENSES = "expense/fetch";

//Unit Utilities
const ADD_UNIT_UTILITY = 'unit_utility/add';
const UPDATE_UNIT_UTILITY = 'unit_utility/update';
const DELETE_UNIT_UTILITY = 'unit_utility/delete';
const FETCH_UNIT_UTILITIES = 'unit_utilities/fetch';
const FETCH_PROPERTY_UTILITIES = 'property_unit_utilities/fetch';
const ADD_UTILITIES_BULK = 'utilities/add_bulk';
const BULK_CREATE_UTILITY_INVOICES = "utilities/invoices_bulk_create";
const RESET_UTILITIES = 'utilities/reset';


//Authorization
const UPDATE_AUTHORIZED = 'authorized/update';
const VERIFY_TOKEN = 'token/verify';

//FeedBack modal
const REMOVE_MODAL = 'feeback_modal/remove';

//Loading indicator
const SHOW_LOADING = 'loading_indicator/show';

const FETCH_OPTIONS = "options/fetch";
const UPDATE_REPORT_SETTINGS = "report_settings/update"

//errors
const SHOW_ERROR = "error/show"; // Network errors
const SHOW_CUSTOM_ERROR = "error/custom";


// user
const LOG_OUT_USER = 'user/logout';
const LOG_IN_USER = 'user/login';
const FETCH_USER = 'user/fetch';
//Feature coming soon alert
const FEATURE_COMING_SOON = 'feature/coming_soon';

//Send Messages (uses settings to determine channels: SMS, Email, WhatsApp)
const SEND_MESSAGE = 'message/send';
const SEND_INVOICE = 'invoice/send';
const SEND_PAYMENT_RECEIPT = 'payment_receipt/send';
const SEND_PAYMENT_REMINDER = 'payment_reminder/send';
const SEND_BULK_PAYMENT_REMINDER = 'bulk_payment_reminder/send';
const SEND_TENANT_STATEMENT = "tenant_statement/send";
const RESEND_MESSAGE = 'message/resend';

//Mpesa Stk Push
const MPESA_STK= 'mpesa_stk/push'

//Fetch dashboard summaries
const FETCH_DASHBOARD_SUMMARY = 'dashboard_summary/fetch'

// No tenant in unit modal
const NO_TENANT_IN_UNIT = 'error/no_tenant'

// Invalid Utility rate
const INVALID_UTILITY_RATE = "error/invalidUtilityRate";

// Generate reports
const GENERATE_REPORTS = 'reports/generate'
const GENERATE_MULTI_PROPERTY_REPORTS = 'reports/multi-property'
const GENERATE_ARREARS_REPORTS = 'reports/arrears/generate'
const GENERATE_EXPENSES_REPORTS = 'reports/expenses/generate'
const GENERATE_MONTH_ON_MONTH_REPORTS = 'reports/mom/generate'
const GENERATE_YEAR_ON_YEAR_REPORTS = 'reports/yoy/generate'
const GENERATE_PROPERTY_GROUPING_REPORT = 'reports/property_grouping/generate'
const GENERATE_DELETED_TENANTS_REPORT = 'reports/deleted_tenants/generate'
const DOWNLOAD_TENANT_TRANSACTIONS_REPORT = 'tenant_transactions/download'
const DOWNLOAD_TENANTS_REPORT = "reports/tenants/download";

// Preferences
const FETCH_PREFERENCES = 'preferences/fetch'
const SET_DEFAULT_PREFERENCES = 'preferences/set-default'
const UPDATE_PREFERENCES = 'preferences/update'

// Settings
const FETCH_SETTINGS = 'settings/fetch';
const UPDATE_SETTINGS = 'settings/update';

// currencies
const FETCH_CURRENCY = 'currency/fetch';
const UPDATE_CURRENCY = 'currency/update'

// Timezones
const FETCH_TIMEZONE = 'timezones/fetch'
const UPDATE_TIMEZONE = 'timezones/update'


// Maintenance
const ADD_MAINTENANCE = 'maintenance/add'
const UPDATE_MAINTENANCE = 'maintenance/update'
const DELETE_MAINTENANCE = 'maintenance/delete'
const FETCH_MAINTENANCES = 'maintenance/fetch'

// Billing
const FETCH_BILLING_DETAILS = '/billing/fetch'
const UPDATE_SMS_ALERT_PREFERENCES = 'billing/setting/update'
const UPDATE_BILLING_PLAN = 'billing/plan/update'

// Messages
const FETCH_MESSAGES = 'messages/fetch';

const PASSWORD_RESET = "password/reset";
// Download invoice or receipt
const DOWNLOAD_INVOICE_OR_RECEIPT = 'document/download'


// Download invoices and payments
const DOWNLOAD_TRANSACTIONS = 'transactions/download';

// Download File
const DOWNLOAD_FILE = "files/download";

// Activity log
const FETCH_ACTIVITY_LOG = "activity_log/fetch";

// Support
const ASK_SUPPORT = "support/ask";

const FEEDBACK_MESSAGE = "feedback";

const FETCH_BANK_ACCOUNTS = "bank_account/fetch";
const ADD_BANK_ACCOUNT = "bank_account/add";
const UPDATE_BANK_ACCOUNT = "bank_account/update";
const DELETE_BANK_ACCOUNTS = "bank_account/delete";
const FETCH_STATEMENT_BANK_ACCOUNT = "bank_account/fetch_statement";

// Bank Statement
const FETCH_BANK_STATEMENT_TRANSACTIONS = "bankStatementTransactions/fetch";
const SAVE_BANK_STATEMENT_TRANSACTIONS = "bankStatementTransactions/save";

// Withdrawals
const ADD_WITHDRAWALS_MOBILE_ACCOUNTS='withdrawals/mobile_account/add'
const ADD_WITHDRAWALS_BANK_ACCOUNTS='withdrawals/bank_account/add'
const UPDATE_WITHDRAWALS_MOBILE_ACCOUNTS='withdrawals/mobile_account/update'
const UPDATE_WITHDRAWALS_BANK_ACCOUNTS='withdrawals/bank_account/update'
const DELETE_WITHDRAWALS_MOBILE_ACCOUNTS='withdrawals/mobile_account/delete'
const DELETE_WITHDRAWALS_BANK_ACCOUNTS='withdrawals/bank_account/delete'
const FETCH_WALLET_BALANCE='wallet_balance/fetch'
const FETCH_WITHDRAWALS_BANK_ACCOUNTS='withdrawals/bank_account/fetch'
const FETCH_WITHDRAWALS_MOBILE_ACCOUNTS='withdrawals/mobile_account/fetch'
const SEND_OTP = "send-otp"
const VERIFY_OTP= "verification"
const WITHDRAWAL_REQUEST="withdrawal-request"
const FETCH_WITHDRAWALS_DATA="withdrawals/fetch"
const CANCEL_WITHDRAWAL_REQUEST="withdrawals/cancel"

// Onboarding
const FETCH_ONBOARDING = "onboarding/fetch"
const DECLINE_ONBOARDING = "onboarding/decline"

//survey
const FETCH_SURVEY_STATUS = "survey/fetch"
const UPDATE_SURVEY = "survey/update"

//paystack
const INITIALIZE_PAYSTACK_TRANSACTION = "paystack/initialize"
const CANCEL_CARD_SUBSCRIPTION = "paystack/cancel-subscription"

// Push Notifications
const REGISTER_PUSH_TOKEN = "push_notifications/register_token"

export {
    ADD_LANDLORD,UPDATE_LANDLORD,FETCH_LANDLORDS, DELETE_LANDLORD,
    ADD_PROPERTY, UPDATE_PROPERTY, DELETE_PROPERTY,
    ADD_UNIT, UPDATE_UNIT, DELETE_UNIT,
    ADD_TENANT, UPDATE_TENANT, DELETE_TENANT, GET_TENANT_IN_UNIT, FETCH_TENANTS, FETCH_PROPERTY_TENANTS,
    PROPERTIES_UNITS_FETCH_INITIAL_DATA,LOAD_PROPERTIES, LOAD_UNITS, SHIFT_TENANT,
    ADD_TEAM_MEMBER, UPDATE_TEAM_MEMBER, DELETE_TEAM_MEMBER,
    ADD_PAYMENT, UPDATE_PAYMENT, DELETE_PAYMENTS, FETCH_PAYMENTS, ASSIGN_PAYMENT, REALLOCATE_PAYMENT,
    ADD_INVOICE, BULK_ADD_INVOICES, UPDATE_INVOICE, DELETE_INVOICES, FETCH_INVOICES, CREATE_PROPERTY_INVOICES,
    ADD_EXPENSE, UPDATE_EXPENSE, DELETE_EXPENSE, FETCH_EXPENSES, CREATE_RECURRING_BILLS_INVOICES,
    CALCULATE_BULK_INVOICES, CREATE_BULK_INVOICES,
    FETCH_TRANSACTIONS,
    BULK_UPLOAD, FETCH_OPTIONS, UPDATE_REPORT_SETTINGS, FETCH_SINGLE_INVOICE,
    UPDATE_AUTHORIZED, VERIFY_TOKEN,
    LOAD_PROPERTIES_UNITS_TENANTS,
    REMOVE_MODAL, SHOW_LOADING, MPESA_STK,
    FETCH_TEAM, SHOW_ERROR, SHOW_CUSTOM_ERROR,
    LOG_OUT_USER, LOG_IN_USER, FETCH_USER,
    FEATURE_COMING_SOON,
    SEND_MESSAGE, RESEND_MESSAGE, FETCH_DASHBOARD_SUMMARY, SEND_INVOICE, SEND_TENANT_STATEMENT,
    SEND_PAYMENT_RECEIPT,SEND_BULK_PAYMENT_REMINDER,
    ADD_UNIT_UTILITY, UPDATE_UNIT_UTILITY, DELETE_UNIT_UTILITY, FETCH_UNIT_UTILITIES, NO_TENANT_IN_UNIT,
    GENERATE_REPORTS, GENERATE_MULTI_PROPERTY_REPORTS, GENERATE_ARREARS_REPORTS, GENERATE_EXPENSES_REPORTS, GENERATE_MONTH_ON_MONTH_REPORTS, GENERATE_YEAR_ON_YEAR_REPORTS, GENERATE_PROPERTY_GROUPING_REPORT, GENERATE_DELETED_TENANTS_REPORT, FETCH_PREFERENCES, SET_DEFAULT_PREFERENCES, UPDATE_PREFERENCES,
    ADD_MAINTENANCE, UPDATE_MAINTENANCE, DELETE_MAINTENANCE, FETCH_MAINTENANCES,
    DOWNLOAD_TENANT_TRANSACTIONS_REPORT, SEND_PAYMENT_REMINDER, UPLOAD_BULK_TRANSACTIONS,
    FETCH_BILLING_DETAILS,
    FETCH_MESSAGES, ASK_SUPPORT,
    FETCH_PROPERTY_UTILITIES, ADD_UTILITIES_BULK, INVALID_UTILITY_RATE, BULK_CREATE_UTILITY_INVOICES,
    DOWNLOAD_INVOICE_OR_RECEIPT,
    PASSWORD_RESET, DOWNLOAD_TRANSACTIONS, DOWNLOAD_FILE,
    FETCH_SETTINGS, UPDATE_SETTINGS, UPDATE_SMS_ALERT_PREFERENCES, FETCH_CURRENCY, UPDATE_CURRENCY,
    FETCH_ACTIVITY_LOG, FETCH_FINANCIALS_GRAPH,
    FEEDBACK_MESSAGE, INITIALIZE_PAYSTACK_TRANSACTION, CANCEL_CARD_SUBSCRIPTION,
    FETCH_BANK_ACCOUNTS, ADD_BANK_ACCOUNT, UPDATE_BANK_ACCOUNT,
    DELETE_BANK_ACCOUNTS, FETCH_STATEMENT_BANK_ACCOUNT,
    FETCH_BANK_STATEMENT_TRANSACTIONS, SAVE_BANK_STATEMENT_TRANSACTIONS,
    DOWNLOAD_TENANTS_REPORT, FETCH_WALLET_BALANCE, FETCH_WITHDRAWALS_BANK_ACCOUNTS, FETCH_WITHDRAWALS_MOBILE_ACCOUNTS,
    ADD_WITHDRAWALS_BANK_ACCOUNTS, ADD_WITHDRAWALS_MOBILE_ACCOUNTS, UPDATE_WITHDRAWALS_BANK_ACCOUNTS, UPDATE_WITHDRAWALS_MOBILE_ACCOUNTS,
    DELETE_WITHDRAWALS_BANK_ACCOUNTS, DELETE_WITHDRAWALS_MOBILE_ACCOUNTS,
    FETCH_TIMEZONE, UPDATE_TIMEZONE, SEND_OTP, VERIFY_OTP, WITHDRAWAL_REQUEST,
    FETCH_WITHDRAWALS_DATA, CANCEL_WITHDRAWAL_REQUEST, FETCH_ONBOARDING, DECLINE_ONBOARDING,
    FETCH_TENANT_DATA, UPDATE_SURVEY, FETCH_SURVEY_STATUS, RESET_UTILITIES, UPDATE_BILLING_PLAN,
    REGISTER_PUSH_TOKEN
};